import {Component, OnDestroy, OnInit} from '@angular/core';
import {TableService, VisitedService} from "@amlCore/services";
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {DictionariesService} from "../../../service/dictionaries.service";
import {TableController} from "@amlCore/tableController";
import {Utils} from "@amlCore/utils";
import {QrefOkwed} from "../../../../../../api/build";

@Component({
  selector: 'app-dictionary-qrefokwed',
  templateUrl: './qrefOkwed.component.html'
})
export class QrefOkwedComponent extends TableController implements OnInit, OnDestroy {

  constructor(protected dictSrv: DictionariesService,
              protected visitedService: VisitedService,
              protected tableService: TableService
  ) {
    super(visitedService, tableService);
  }
  data: QrefOkwed[] = [];

  public goBack = Utils.goBack;

  private destroy$ = new Subject<void>();
  isShowVisited = false;
  isSetFocus = false;

  ngOnInit() {
    this.loadDict();
  }

  loadDict() {
    this.dictSrv.getQrefOkwedList().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.data = data.content;
    });
  }
  onPageChange(params): void {
    this.loadDict();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


